;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { User } from '@qogita/canary-client'
import {
  InlineNotification,
  InlineNotificationActionAnchor,
} from '@qogita/ui/v2/inline-notification'
import React from 'react'
import { EMAILS } from 'src/core/constants/copy'

type InlineNotificationType = React.FC<{
  expectedPauseEnd?: number | null
}>

const TRAINING_REQUIRED_TITLE = 'Qogita account paused'
const TRAINING_REQUIRED_DESCRIPTION =
  'You won’t receive any new orders until your account is unpaused. Please contact us to discuss unpausing your account.'
const TRAINING_REQUIRED_CONTACT_LABEL = 'Contact us'

const TECHNICAL_ISSUE_TITLE =
  'We are fixing a technical issue with your account'
const TECHNICAL_ISSUE_DESCRIPTION =
  'You won’t receive any new orders until we have resolved the issue. Please contact us if you have any questions.'
const TECHNICAL_ISSUE_CONTACT_LABEL = 'Contact us'
const CONTACT_US_RUM_ACTION_NAME =
  'PausedSellerReasonInlineNotification Contact Us'

const SellerTrainingRequiredInlineNotification: InlineNotificationType = () => {
  return (
    <div className="col-span-8 mb-6 max-w-5xl">
      <InlineNotification
        emphasis="medium"
        theme="caution"
        title={TRAINING_REQUIRED_TITLE}
        message={TRAINING_REQUIRED_DESCRIPTION}
        actions={
          <InlineNotificationActionAnchor
            href={`mailto:${EMAILS.procurement}`}
            rumActionName={CONTACT_US_RUM_ACTION_NAME}
          >
            {TRAINING_REQUIRED_CONTACT_LABEL}
          </InlineNotificationActionAnchor>
        }
      />
    </div>
  )
}

const TechnicalIssueInlineNotification: InlineNotificationType = () => {
  return (
    <div className="col-span-8 mb-6 max-w-5xl">
      <InlineNotification
        emphasis="medium"
        theme="caution"
        title={TECHNICAL_ISSUE_TITLE}
        message={TECHNICAL_ISSUE_DESCRIPTION}
        actions={
          <InlineNotificationActionAnchor
            href={`mailto:${EMAILS.procurement}`}
            rumActionName={CONTACT_US_RUM_ACTION_NAME}
          >
            {TECHNICAL_ISSUE_CONTACT_LABEL}
          </InlineNotificationActionAnchor>
        }
      />
    </div>
  )
}

const SellerRequestedPauseInlineNotification: InlineNotificationType = () => {
  return (
    <div className="col-span-8 mb-6 max-w-5xl">
      <InlineNotification
        emphasis="medium"
        theme="caution"
        title="You requested not to receive new orders during your facility-closure"
        message={
          <>
            <p>
              You won&apos;t receive any new orders until your facility
              re-opens.
            </p>
            <p className="mt-2">
              Please contact us if you are able to receive orders earlier than
              previously indicated.
            </p>
          </>
        }
        actions={
          <InlineNotificationActionAnchor
            href={`mailto:${EMAILS.success}`}
            rumActionName={CONTACT_US_RUM_ACTION_NAME}
          >
            Contact us
          </InlineNotificationActionAnchor>
        }
      />
    </div>
  )
}

/*
 * Returns null if the seller is not currently paused or if the reason should not be displayed to the seller.
 */
function getReasonForPausedSeller(user: User) {
  // not paused sellers do not have a visible reason
  if (user.sellerStatus !== 'PAUSED') return null

  return user.pauseReason
}

const ComponentForReason = {
  NEW_SELLER: null,
  SELLER_TRAINING_REQUIRED: SellerTrainingRequiredInlineNotification,
  SELLER_SIDE_ISSUE: TechnicalIssueInlineNotification,
  SELLER_OUT_OUF_OFFICE: SellerRequestedPauseInlineNotification,
}

export const PausedSellerReasonInlineNotification = ({
  user,
}: {
  user: User
}) => {
  const reason = getReasonForPausedSeller(user)
  const showPausedNotification = reason !== null

  if (!showPausedNotification) return null

  const Component = ComponentForReason[reason]

  if (!Component) return null // if the backend sends a reason that we don't have a component for, don't show the modal

  return <Component expectedPauseEnd={user.expectedPauseEnd} />
}
